import { FileText } from "lucide-react";

import { BarChartCard } from "./BarChartCard";
import { formatCount } from "./chartPalette";
import { ChartsGrid, InsightsPanel, StatsRow } from "./InsightsLayout";
import { StatCard } from "./StatCard";
import { TrendChartCard } from "./TrendChartCard";

export const LettersInsights = ({ insights, isLoading }) => {
  return (
    <InsightsPanel>
      <StatsRow>
        <StatCard label="Total Letters" icon={FileText} isLoading={isLoading}
          value={formatCount(insights?.totalLetters)} />
      </StatsRow>
      <ChartsGrid>
        <BarChartCard title="By Name" data={insights?.byName} isLoading={isLoading} />
        <BarChartCard title="By Doctor" data={insights?.byDoctor} isLoading={isLoading} />
        <TrendChartCard title="Letters Over Time" data={insights?.trendByDay} isLoading={isLoading} />
      </ChartsGrid>
    </InsightsPanel>
  );
};
